import TimeUnits from "../../constants/TimeUnits";
import { setDecelerationInterval } from "../../utils/Timer";
import AnalyticsVersions from "./AnalyticsVersions";
/**
 * resolveAnalyticsVersion
 * Helper to detect analytics version by what's currently
 * being loaded.
 */
export var resolveAnalyticsVersion = function () {
    if ("adobeDataLayer" in window) {
        return AnalyticsVersions.WebSdk;
    }
    else if ("s_gi" in window) {
        return AnalyticsVersions.DynamicTagManagement;
    }
    return null;
};
/**
 * resolveAnalyticsGlobalByVersion
 * Helper to obtain the Analytics global for the given version
 */
export var resolveAnalyticsGlobalByVersion = function (version) {
    var win = window;
    switch (version) {
        case AnalyticsVersions.DynamicTagManagement:
            return win.s_gi || null;
        case AnalyticsVersions.WebSdk:
            return win.adobeDataLayer || null;
    }
    return null;
};
/**
 * resolveAnalyticsVersionWhenReady
 * Returns a promise which resolves the analytics versions.
 * The promise will resolve once analytics has been loaded.
 * @Warning - when multiple versions are loaded, it will take the first detected once...
 */
export var resolveAnalyticsVersionWhenReady = function () {
    return getVersionResolverPromise();
};
/**
 * Private
 */
/**
 * getVersionResolverPromise
 * The following process checks for 30 seconds to determine
 * the loaded Analytics version.
 * @Note - the Promise instance is a singleton
 * @TODO - implement
 */
var getVersionResolverPromise = function () {
    var fn = getVersionResolverPromise;
    if (!fn._promise) {
        fn._promise = new Promise(function (resolve, reject) {
            var startTime = new Date().getTime();
            var timeout = TimeUnits.Second * 30; // 30 seconds
            var stopInterval = setDecelerationInterval(function () {
                try {
                    var version = resolveAnalyticsVersion();
                    var hasExpired = new Date().getTime() - startTime > timeout;
                    if (version || hasExpired) {
                        stopInterval();
                        resolve(version);
                    }
                }
                catch (error) {
                    stopInterval();
                    reject(error);
                }
            }, 100, 1);
        });
    }
    return fn._promise;
};
/**
 * resolveAllAnalyticsVersions
 * Helper function to detect all active analytics versions on a page.
 */
export var resolveAllAnalyticsVersions = function () {
    var activeVersions = [];
    if ("adobeDataLayer" in window) {
        activeVersions.push(AnalyticsVersions.WebSdk);
    }
    else if ("s_gi" in window) {
        activeVersions.push(AnalyticsVersions.DynamicTagManagement);
    }
    return activeVersions;
};
/*
* resolveAnalyticsVersionByTakingIntoAccountThePreferredVersion
* Helper function to determine whether a preferred analytics version is also active.
* If so, use that one. Otherwise use the primary one.
*
* This is usefull because multiple versions could be active at the same time on a specific website.
*
* @param preferredVersion
*/
export var resolveAnalyticsVersionByTakingIntoAccountThePreferredVersion = function (preferredVersion, version) {
    if (version === void 0) { version = resolveAnalyticsVersion(); }
    if (version !== preferredVersion) {
        var allAnalyticsVersions = resolveAllAnalyticsVersions();
        var isPreferredAlsoActive = allAnalyticsVersions.includes(preferredVersion);
        if (isPreferredAlsoActive) {
            return preferredVersion;
        }
    }
    return version;
};
//# sourceMappingURL=Utils.js.map